import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { formRules } from "@/js/form_rules.js";
import { request } from "@/js/http/http_request";
import { DOCUMENT_TAGS } from "@/js/lists.ts";
import { getErrorData } from "@/js/forms.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "ManageDocumentsTagsDialog",
  components: {
    confirm: confirmationComponent
  },
  data: function data() {
    return {
      dialog: false,
      editDialogShown: false,
      loadingDocumentTags: false,
      documentTags: [],
      documentTagsTotalNumber: null,
      form: {
        valid: false,
        loading: false,
        name: null,
        isVisibleToCustomer: false,
        id: null,
        editMode: false
      },
      documentTagErrors: {
        tag_used_on_document: {
          code: "tag_used_on_document",
          message: "This tag is used on documents"
        },
        tag_already_exists: {
          code: "tag_already_exists",
          message: "Tag with same name already exists."
        }
      },
      editedTagValue: null,
      headers: [{
        text: "Tag name",
        align: "start",
        sortable: false,
        value: "name"
      }, {
        text: "Customer visibility",
        align: "center",
        sortable: false,
        value: "isVisibleToCustomer"
      }, {
        text: "Tag in use number",
        align: "center",
        sortable: false,
        value: "inUseNumber"
      }, {
        text: "Actions",
        align: "center",
        sortable: false,
        value: "actions"
      }],
      managedExceptions: {
        warning: {
          tag_used_on_document: "This tag is used on documents",
          tag_already_exists: "Tag with same name already exists."
        }
      },
      formRules: formRules,
      DOCUMENT_TAGS: DOCUMENT_TAGS
    };
  },
  created: function created() {},
  methods: {
    openDialog: function openDialog() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.dialog = true;
              _context.next = 3;
              return _this2.fetchDocumentTags();
            case 3:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                _this2.resolve = resolve;
                _this2.reject = reject;
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    close: function close() {
      this.dialog = false;
    },
    cancel: function cancel() {
      this.editDialogShown = false;
      this.form = {
        name: null,
        id: null,
        editMode: false
      };
    },
    fetchDocumentTags: function fetchDocumentTags() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _this.loadingDocumentTags = true;
              _context2.next = 4;
              return request("/v1/document-tags/all", "get", null, true, "api").then(function (response) {
                _this.documentTags = response.data.items;
                _this.documentTagsTotalNumber = response.data.totalNumber;
                _this.loadingDocumentTags = false;
                _this.$emit("documentTagsFetched", _this.documentTags);
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    saveNewTag: function saveNewTag() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this4;
              _this.form.loading = true;
              _context3.next = 4;
              return request("/v1/document-tags", "post", {
                tagName: _this.form.name,
                isVisibleToCustomer: _this.form.isVisibleToCustomer
              }, true, "api").then(function (response) {
                _this.form.name = null;
                _this.editDialogShown = false;
                _this.fetchDocumentTags();
                _this.$emit("tagListChanged");
                _this.$toasted.show("Document tag added successfully.", {
                  type: "success"
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
              _this.form.loading = false;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    deleteTag: function deleteTag(tagId) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this5;
              _this.$refs.confirm.open("Delete", "Are you sure you want to delete this tag ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(confirm) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!confirm) {
                          _context5.next = 4;
                          break;
                        }
                        _this.loadingDocumentTags = true;
                        _context5.next = 4;
                        return request("/v1/document-tags/" + tagId, "delete", {
                          bypassUsedOnDocumentError: false
                        }, true, "api").then(function (response) {
                          _this.fetchDocumentTags();
                          _this.$emit("tagListChanged");
                          _this.$toasted.show("Document tag deleted successfully.", {
                            type: "success"
                          });
                        }).catch(function (e) {
                          var _e$response;
                          if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.errorCode) === documentTagErrors.tag_used_on_document.code) {
                            var _e$response2;
                            _this.$refs.confirm.open("Confirm Delete", (e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.data) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.value) === null || _e$response2 === void 0 ? void 0 : _e$response2.message) + ", Are you sure you want to delete it ?" + " The tag will be deleted and the documents will no longer be tagged.", {
                              color: "red"
                            }).then(/*#__PURE__*/function () {
                              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(confirm) {
                                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                                  while (1) switch (_context4.prev = _context4.next) {
                                    case 0:
                                      if (!confirm) {
                                        _context4.next = 3;
                                        break;
                                      }
                                      _context4.next = 3;
                                      return request("/v1/document-tags/" + tagId, "delete", {
                                        bypassUsedOnDocumentError: true
                                      }, true, "api").then(function (response) {
                                        _this.fetchDocumentTags();
                                        _this.$emit("tagListChanged");
                                        _this.$toasted.show("Document tag deleted successfully.", {
                                          type: "success"
                                        });
                                      }).catch(function () {
                                        _this.$toasted.show("Document tag couldn't be deleted.", {
                                          type: "error"
                                        });
                                      });
                                    case 3:
                                    case "end":
                                      return _context4.stop();
                                  }
                                }, _callee4);
                              }));
                              return function (_x2) {
                                return _ref2.apply(this, arguments);
                              };
                            }());
                            return;
                          }
                          _this.$toasted.show("Document tag couldn't be deleted.", {
                            type: "error"
                          });
                        });
                      case 4:
                        _this.loadingDocumentTags = false;
                      case 5:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    openEditTag: function openEditTag(item) {
      this.form = {
        name: item.name,
        isVisibleToCustomer: item.isVisibleToCustomer,
        id: item.id,
        editMode: true
      };
      this.editDialogShown = true;
    },
    updateTag: function updateTag() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, tagData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this6;
              _this.loadingDocumentTags = true;
              if (!_this.form.editMode) {
                _this.$toasted.show("Unable to update document tag.", {
                  type: "error"
                });
              }
              tagData = {
                name: _this.form.name,
                isVisibleToCustomer: _this.form.isVisibleToCustomer,
                id: _this.form.id
              };
              _context7.next = 6;
              return request("/v1/document-tags", "put", tagData, true, "api").then(function (response) {
                _this.form.name = null;
                _this.editDialogShown = false;
                _this.fetchDocumentTags();
                _this.$emit("tagListChanged");
                _this.$toasted.show("Document tag updated successfully.", {
                  type: "success"
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 6:
              _this.loadingDocumentTags = false;
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  }
};